import { fmtDateShort, fmtDayMonth } from '@siva/shared';

/**
 * "3 Aug – 9 Aug 2026", "28 Sep – 4 Oct 2026", "29 Dec 2025 – 4 Jan 2026": each end names its
 * month, and the year is said once unless the week straddles it. Two full dates wrapped to two
 * lines on a 360px phone; "3 – 9 Aug" was shorter still, and the owner wanted the month on both.
 */
export function weekLabel(start: string, end: string): string {
  const sameYear = start.slice(0, 4) === end.slice(0, 4);
  if (sameYear) return `${fmtDayMonth(start)} – ${fmtDateShort(end)}`;
  return `${fmtDateShort(start)} – ${fmtDateShort(end)}`;
}
